var AreaLayer = /* @__PURE__ */ ((AreaLayer2) => {
  AreaLayer2["province"] = "province";
  AreaLayer2["ward"] = "ward";
  return AreaLayer2;
})(AreaLayer || {});
var LocalGovernmentModel = /* @__PURE__ */ ((LocalGovernmentModel2) => {
  LocalGovernmentModel2["THREE_LEVEL"] = "three_level";
  LocalGovernmentModel2["TWO_LEVEL"] = "two_level";
  return LocalGovernmentModel2;
})(LocalGovernmentModel || {});

export { AreaLayer, LocalGovernmentModel };
